module.exports = __webpack_public_path__ + "img/problem.e5b955e3.svg";